import { WEAPON_SKIN_SPRITES_V1, type WeaponSkinSprite, type WeaponSkinSpriteKey } from '../reference/weapon-skin-sprites-v1.js';

export const WEAPON_SKIN_URL_PREFIX = '/assets/weapons/';

export interface LoadedWeaponSkin { readonly image: unknown; readonly sprite: WeaponSkinSprite }
/** Returns a skin only once its image is decoded; callers fall back to line art otherwise. */
export type WeaponSkinLookup = (key: WeaponSkinSpriteKey) => LoadedWeaponSkin | undefined;

interface LoadableImage { src: string; onload: ((...args: never[]) => unknown) | null; onerror: ((...args: never[]) => unknown) | null }

/** Starts every download once; rendering never fetches per frame. */
export function preloadWeaponSkins(createImage: () => LoadableImage): WeaponSkinLookup {
  const ready = new Map<WeaponSkinSpriteKey, LoadedWeaponSkin>();
  for (const [key, sprite] of Object.entries(WEAPON_SKIN_SPRITES_V1) as [WeaponSkinSpriteKey, WeaponSkinSprite][]) {
    const image = createImage();
    image.onload = () => { ready.set(key, { image, sprite }); };
    image.onerror = () => { ready.delete(key); };
    image.src = WEAPON_SKIN_URL_PREFIX + sprite.file;
  }
  return (key) => ready.get(key);
}
